'use client';

import { Heading, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';

import { clsx } from '@libs/common-next';

import type { LeftNavigationProps } from '@/components/HelpArticle/types';

import { trackHelpSectionClick } from '../analytics';

import './LeftNavigation.scss';

export default function LeftNavigation({ question, answers, pageName }: LeftNavigationProps) {
    return (
        <div className="help-article__navigation">
            <Heading tagName="h6" className="help-article__navigation__heading">
                {question}
            </Heading>
            {answers.map(({ fields: { link, actionText } }) => (
                <Link
                    key={link.sys.id}
                    href={link.fields.webUrl}
                    prefetch={false} // https://petsmart.atlassian.net/browse/SB-325
                    className={clsx('help-article__navigation__item', pageName === actionText && 'help-active')}
                    onClick={() => trackHelpSectionClick(question, actionText)}
                >
                    <TextPassage>{actionText}</TextPassage>
                </Link>
            ))}
        </div>
    );
}
